<template>
  <div>
    <el-container>
      <el-main>
        <el-row>
          <el-col :span="24">
            <ReportByProductByMonthFilters
              isFrom="RequestReporByType"
              @onYearSelected="OnYearSelected"
              @thecnicianChaged="OnThecnicianChaged"
              @customerServiceChanged="OnCustomerServiceChanged"
              @resquestTypeChanged="OnRequestTypeChanged"
              @productChanged="OnProductChanged"
            />
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <ReportByTypeByMonthTable
              :yearSelected="yearSelected"
              :thecnicianSelected="thecnicianSelected"
              :customerServiceCode="customerServiceCode"
              :ProductSelected="ProductSelected"
              @OpeningDetailDialosg="OnDetailDialogOpen"
            />
          </el-col>
        </el-row>
        <MonthlyRequestByTypeReportDetail
          :DialoVisible="detailDialogVisible"
          :YearSelected="yearSelected"
          :ThecnicianSelected="thecnicianSelected"
          :CustomerServiceCode="customerServiceCode"
          :Month="monthSelected"
          :RequestTypeId="requestTypeId"
          :RequestTypeName="requestTypeName"
          :ProductSelected="ProductSelected"
          @ClosingDialog="OnDetailDialogClose"
        />
      </el-main>
    </el-container>
  </div>
</template>

<script>
import ReportByProductByMonthFilters from "@/components/requests/reports/reportByproductByMonth/ReportByProductByMonthFilters";
import ReportByTypeByMonthTable from "@/components/requests/reports/ReportByTypeByMonth/ReportByTypeByMonthTable";
import MonthlyRequestByTypeReportDetail from "@/components/requests/reports/ReportByTypeByMonth/detail/MonthlyRequestByTypeReportDetail";

const actualYear = new Date().getFullYear();

export default {
  name: "RequestByType",
  components: {
    ReportByProductByMonthFilters,
    ReportByTypeByMonthTable,
    MonthlyRequestByTypeReportDetail
  },
  data() {
    return {
      yearSelected: actualYear,
      monthSelected: null,
      thecnicianSelected: 0,
      customerServiceCode: 0,
      requestTypeSelected: 0,
      ProductSelected: 0,
      requestTypeId: null,
      requestTypeName: "",
      detailDialogVisible: false
    };
  },

  mounted() {},

  methods: {
    OnYearSelected(year) {
      this.yearSelected = year;
    },
    OnThecnicianChaged(thecnicianId) {
      this.thecnicianSelected = thecnicianId;
    },
    OnCustomerServiceChanged(customerServiceCode) {
      this.customerServiceCode = customerServiceCode;
    },
    OnRequestTypeChanged(requestType) {
      this.requestTypeSelected = requestType;
    },
    OnProductChanged(productId) {
      this.ProductSelected = productId;
    },
    OnDetailDialogOpen(val, month, requestTypeId, requestTypeName) {
      this.monthSelected = month;
      this.requestTypeId = requestTypeId;
      this.requestTypeName = requestTypeName;
      this.detailDialogVisible = val;
    },
    OnDetailDialogClose(val) {
      this.detailDialogVisible = val;
    }
  }
};
</script>
